import {
  CASE_DOCUMENTS,
  RESET_CASE_DOCUMENTS,
  RESET_SELECTED_DOCUMENTS,
  SELECTED_CASE_DOCUMENTS,
  UPDATED_CASE_DOCUMENTS,
} from '../actions/actionTypes';
import { formatDocuments } from 'Utils/formatCaseDocumentsUtil';
import initialState from './initialState';

export default function caseDocumentsReducer(state = initialState.caseDocuments, action) {
  switch (action.type) {
    case CASE_DOCUMENTS: {
      const formattedDocs = formatDocuments(action.caseDocuments.data);
      return {
        ...state,
        documentNames: formattedDocs.documentNames,
        documentSize: formattedDocs.documentSize,
        documentTypeNames: formattedDocs.documentTypeNames,
        docReceivedDates: formattedDocs.docReceivedDates,
        disputeStageNames: formattedDocs.disputeStageNames,
        imageToolKitData: formattedDocs.imageToolKitData,
        pageCount: formattedDocs.pageCount,
        pageListArray: formattedDocs.pageListArray,
        issuerImageData: {
          ...state.issuerImageData,
          selectAllFlag: formattedDocs.selectAllFlag,
        },
        merchantImageData: {
          ...state.issuerImageData,
          selectAllFlag: formattedDocs.selectAllFlag,
        },
      };
    }
    case RESET_CASE_DOCUMENTS:
      return {
        ...state,
        documentNames: [],
        documentSize: [],
        documentTypeNames: [],
        docReceivedDates: [],
        disputeStageNames: [],
        imageToolKitData: [],
        pageCount: [],
        pageListArray: [],
        issuerImageData: {
          selectedPages: {},
          addClass: {},
          imageOrderSeq: {},
          pageCount: {},
          selectAllFlag: {},
          orderOfSelectedPages: [],
        },
        merchantImageData: {
          selectedPages: {},
          addClass: {},
          imageOrderSeq: {},
          pageCount: {},
          selectAllFlag: {},
          orderOfSelectedPages: [],
        },
      };
    case SELECTED_CASE_DOCUMENTS:
      return {
        ...state,
        [action.documentType]: {
          ...state[action.documentType],
          imageOrderSeq: action.imageOrderSeq,
          selectedPages: {
            ...state[action.documentType].selectedPages,
            [action.selectedFileIndex]: action.selectedPages,
          },
          pageCount: {
            ...state[action.documentType].pageCount,
            [action.selectedFileIndex]: action.pageCount,
          },
          selectAllFlag: {
            ...state[action.documentType].selectAllFlag,
            [action.selectedFileIndex]: action.selectAllFlag,
          },
          orderOfSelectedPages: action.orderOfSelectedPages,
        },
      };
    case UPDATED_CASE_DOCUMENTS:
      return {
        ...state,
        [action.documentType]: {
          ...state[action.documentType],
          selectedPages: action.selectedPages,
          pageListArray: action.pageListArray,
          imageToolKitData: action.imageToolKitData,
        },
      };
    case RESET_SELECTED_DOCUMENTS:
      return {
        ...state,
        [action.documentType]: {
          selectedPages: {},
          addClass: {},
          imageOrderSeq: {},
          pageCount: {},
          selectAllFlag: {},
          orderOfSelectedPages: [],
        },
      };
    default:
      return state;
  }
}
